import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../store/rootState'

export default function MqSmall (props) {
  const size = useSelector((state: RootState) => state.mq.size)
  return size === 's' ? props.children : null
}
